import { Path, Svg } from "@react-pdf/renderer";

export const PDFCheckSvg = () => (
  <Svg width="12" height="12" viewBox="0 0 19 19">
    <Path
      d="m3.333 9.265 4.5 4.5 7.5-9"
      stroke="#219653"
      strokeWidth="2"
      strokeLineCap="round"
    />
  </Svg>
);
